import { useMemo } from 'react';
import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { GenderChoice } from '../../../common/components/SearchHeader/types/GenderChoice';
import { DropDownEnumFilter } from '../EnumFilter/DropDownEnumFilter/DropDownEnumFilter';
import { Option } from '../EnumFilter/RadioGroup/RadioGroup';
import { DropDownFilterPill } from '../FilterPill/DropDownFilterPill';
import { useOverlay } from '../overlay/OverlayContext';

const TITLE = 'Practitioner gender';

export const GenderFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const handleChange = (gender: GenderChoice | undefined): void => {
    setFilters({ ...filters, gender });
    clear();
  };

  const caption = useMemo(() => {
    if (filters.gender === GenderChoice.FEMALE) return 'Female';
    if (filters.gender === GenderChoice.MALE) return 'Male';
    return TITLE;
  }, [filters.gender]);

  const handleClear = () => setFilters({ ...filters, gender: undefined });

  return (
    <DropDownFilterPill
      hasValue={filters.gender !== undefined}
      onClear={handleClear}
      caption={caption}
      trackingId={LinkId.FILTER_BY_GENDER_BUTTON}
      content={
        <DropDownEnumFilter<GenderChoice | undefined>
          value={filters.gender}
          filterTitle={TITLE}
          options={OPTIONS}
          onChange={handleChange}
        />
      }
    />
  );
};

const OPTIONS: Option<GenderChoice | undefined>[] = [
  { label: 'Any', value: undefined },
  { label: 'Female', value: GenderChoice.FEMALE },
  { label: 'Male', value: GenderChoice.MALE },
];
